import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function AlertDialogSlide({
  handleOnClose = () => {},
  handleOnAgree = () => {},
  title = "",
  description = "",
  isOpen = false,
  agreeButtonText = "Remove",
  cancelButtonText = "Cancel",
}) {
  const isDestructive =
    agreeButtonText.toLowerCase().includes("remove") ||
    agreeButtonText.toLowerCase().includes("delete") ||
    agreeButtonText.toLowerCase().includes("cancel order");

  return (
    <Dialog
      open={isOpen}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleOnClose}
      aria-describedby="alert-dialog-slide-description"
      PaperProps={{
        sx: {
          borderRadius: {xs: "18px", sm: "22px"},
          p: {xs: 1.5, sm: 2},
          maxWidth: "420px",
          width: "calc(100% - 32px)",
          m: 2,
          boxShadow:
            "0 20px 40px -12px rgba(15, 23, 42, 0.25), 0 0 0 1px rgba(226, 232, 240, 0.8)",
        },
      }}
      BackdropProps={{
        sx: {
          backdropFilter: "blur(6px)",
          backgroundColor: "rgba(15, 23, 42, 0.55)",
        },
      }}
    >
      <DialogTitle
        sx={{
          fontWeight: 800,
          fontSize: {xs: "1.1rem", sm: "1.2rem"},
          color: "#0f172a",
          pb: 1,
        }}
      >
        {title}
      </DialogTitle>
      <DialogContent sx={{pb: 2}}>
        <DialogContentText
          id="alert-dialog-slide-description"
          sx={{
            color: "text.secondary",
            fontSize: "0.88rem",
            lineHeight: 1.5,
          }}
        >
          {description}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{px: 2, pb: 1, gap: 1}}>
        <Button
          onClick={handleOnClose}
          variant="outlined"
          sx={{
            textTransform: "none",
            fontWeight: 600,
            borderRadius: "10px",
            px: 2.5,
            borderColor: "#cbd5e1",
            color: "#475569",
            "&:hover": {
              borderColor: "#94a3b8",
              bgcolor: "#f1f5f9",
            },
          }}
        >
          {cancelButtonText}
        </Button>
        <Button
          onClick={handleOnAgree}
          variant="contained"
          sx={{
            textTransform: "none",
            fontWeight: 700,
            borderRadius: "10px",
            px: 2.5,
            bgcolor: isDestructive ? "#dc2626" : "primary.main",
            "&:hover": {
              bgcolor: isDestructive ? "#b91c1c" : "primary.dark",
            },
          }}
        >
          {agreeButtonText}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
